import Template from './compare.component.html';

export const CompareTemplate = Template;

/* @ngInject */
export default function CompareComponent($scope, $location, $timeout, $window, $translate, IconFormatterService, CacheService,
                                         UniquePartModelService, $uibModalInstance, ContainerInfoApiService, __env, SleuthService,
                                         CompareApiService) {
    $scope.parameterNames = [];
    $scope.formattedUniqueParts = [];
    $scope.searchLabel;

    $scope.documentationUrl = __env.documentationUrl;

    $scope.$watch(
        function () {
            return CacheService.getDefinition();
        },
        function (newValue, oldValue) {
            if (newValue !== oldValue) {
                $scope.definition = CacheService.getDefinition();
                $scope.init();
            }
        }
    );

    $scope.chooseRangeIcon = function (rangeName) {
        return IconFormatterService.chooseParameterIcon(rangeName);
    };

    $scope.chooseRangeIcon = function (rangeName) {
        return IconFormatterService.chooseParameterIcon(rangeName);
    };

    $scope.displayDefinitionName = function (definition) {
        if (definition === undefined) {
            return '';
        }
        if (CacheService.getConfigurationInfo() !== undefined) {
            var displayName = ContainerInfoApiService.getDisplayName(definition, CacheService.getConfigurationInfo().language);
            if (displayName === null) {
                return definition.displayName;
            } else {
                return displayName;
            }
        } else {
            if (definition !== undefined) {
                return definition.displayName;
            } else {
                return ''; // in the case where the view is rendering, and we don't have a definition yet.
            }
        }
    };

    $scope.unique = function (arr) {
        var hash = {}, result = [];
        for (var i = 0, l = arr.length; i < l; ++i) {
            if (!hash.hasOwnProperty(arr[i])) { //it works with objects! in FF, at least
                hash[arr[i]] = true;
                result.push(arr[i]);
            }
        }
        return result;
    };

    $scope.pushParameterIfNotExist = function (parameters, parameter) {
        for (var i = 0; i < parameters.length; ++i) {
            if (parameters[i].name === parameter.name && parameters[i].id === parameter.id) {
                return;
            }
        }
        parameters.push(parameter);
    };

    $scope.isParameterExist = function (parameters, parameter) {
        for (var i = 0; i < parameters.length; ++i) {
            if (parameters[i].name === parameter.name && parameters[i].id === parameter.id) {
                return true;
            }
        }
        return false;
    };

    $scope.rearrangeComparisons = function () {
        var i;
        var foundComparison = null;
        for (i = 0; i < $scope.comparisons.length; ++i) {
            if ($scope.comparisons[i].name === $scope.searchLabel || $scope.comparisons[i].name === 'Search') {
                if (i === 0) {
                    // Add the items to the GET Param in the case that everything is in the right order.
                    $location.search('searchedDefId', $scope.comparisons[0].definitionId);
                    for (i = 0; i < $scope.comparisons.length; ++i) {
                        $location.search('item' + (i), $scope.comparisons[i].uniquePn);
                    }
                    return;
                }
                foundComparison = $scope.comparisons[i];
                break;
            }
        }
        if (foundComparison !== null) {
            $scope.comparisons.splice(i, 1);
            $scope.comparisons.unshift(foundComparison);
        }

        for (i = 0; i < $scope.comparisons.length; ++i) {
            $location.search('item' + (i), $scope.comparisons[i].uniquePn);
            if ($scope.comparisons[i].name === $scope.searchLabel || $scope.comparisons[i].name === 'Search') {
                $location.search('searchedDefId', $scope.comparisons[i].definitionId);
            }
        }
    };

    $scope.getLanguageValue = function (paramValue) {
        var displayParameterValueName = ContainerInfoApiService.getDisplayNameByDisplayNames(paramValue.displayValues,
            CacheService.getConfigurationInfo().language);
        if (displayParameterValueName === null) {
            displayParameterValueName = paramValue.formattedValue;
        }
        return displayParameterValueName;
    };

    $scope.onlyUnique = function (value, index, self) {
        return self.indexOf(value) === index;
    };

    $scope.areDifferent = function (parameterName) {
        var isDifferent = false;
        var value = $scope.formattedUniqueParts[0][parameterName.name + '_' + parameterName.id];
        for (var i = 0; i < $scope.formattedUniqueParts.length; ++i) {
            if (value !== $scope.formattedUniqueParts[i][parameterName.name + '_' + parameterName.id]) {
                isDifferent = true;
                break;
            }
        }
        return isDifferent ? 'difference' : '';
    };

    $scope.removeCompare = function (comparison) {
        var index = $scope.comparisons.indexOf(comparison);
        if ($scope.comparisons.length > 2) {
            $scope.comparisons.splice(index, 1);
            $scope.formattedUniqueParts.splice(index, 1);
        } else {
            $translate('message__comparison__confirmation', 'en').then(function (message) {
                var c = confirm(message);
                if (c === true) {
                    $scope.comparisons.splice(index, 1);
                    $scope.formattedUniqueParts.splice(index, 1);
                    $scope.dismissModal();
                }
            });
        }
    };

    $scope.formatDisplay = function (formattedParameterValue) {
        if (formattedParameterValue === undefined) {
            return '--';
        }
        return formattedParameterValue;
    };

    $scope.fetchPrevious = function (definition) {
        $location.path('browsing/technology').search('id', definition.id);
    };

    // Have some functionality here that once all the .difference classes are in the DOM:
    // find all children of .card-parameter that has class "difference," and add class "non-white," resulting
    // in them having both classes ".difference.non-white" like so, but only as the children of .card-parameter.

    $scope.transferPart = function (part) {
        $uibModalInstance.dismiss('cancel');
        CacheService.storeUniquePart(part);
    };

    $scope.dismissModal = function () {
        $location.search('item0', null);
        $location.search('item1', null);
        $location.search('item2', null);
        $location.search('searchedDefId', null);
        $uibModalInstance.dismiss('cancel');
    };

    $scope.removeSleuthData = function () {
        SleuthService.removeSleuthData();
    };

    $scope.clearSearchBar = function () {
        CacheService.storeOriginalQueryInput(undefined);
    };

    $scope.copyToClipboard = function (valueToCopy) {
        console.log('Copying...', $location.absUrl());
        var copyElement = document.createElement('textarea');
        copyElement.style.position = 'fixed';
        copyElement.style.opacity = '0';
        copyElement.textContent = $location.absUrl();
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
    };

    $scope.getDisplayParameterName = function (parameterValue) {
        var displayParameterName = ContainerInfoApiService.getDisplayNameByDisplayNames(parameterValue.displayNames,
            CacheService.getConfigurationInfo().language);
        if (displayParameterName == null) {
            displayParameterName = parameterValue.displayName;
        }
        return displayParameterName;
    };

    $scope.trackCopyLinkClick = function () {
        if ($window.ga) {
            ga('send', {
                hitType: 'event',
                eventCategory: 'Compare',
                eventAction: 'copyLink',
                eventLabel: 'Copied URL: ' + $location.absUrl()
            });
        }
    };

    $scope.init = function () {
        $translate('label__search', 'en').then(function (searchLabel) {
            if (CacheService.getDefinition() !== undefined) {
                $scope.comparisons = UniquePartModelService.copyCompareQueue();
                $scope.definition = CacheService.getDefinition();
                $scope.searchLabel = searchLabel.valueOf();
                UniquePartModelService.clearCompareQueue();
                $scope.rearrangeComparisons();
                var comparableRequest = '';
                var uniquePns = '';

                if ($scope.comparisons[0].name === $scope.searchLabel || $scope.comparisons[0].name === 'Search') {
                    comparableRequest = {
                        leafDefinitionId: $scope.comparisons[0].definitionId,
                        comparableParameterValues: $scope.comparisons[0].parameterValues
                    };
                    var uniqueParts = $scope.comparisons.slice(1);
                    uniquePns = uniqueParts.map(function (value) {
                        return value.uniquePn;
                    }).join(',');
                } else {
                    uniquePns = $scope.comparisons.map(function (value) {
                        return value.uniquePn;
                    }).join(',');
                }

                CompareApiService.executeComparison(uniquePns, comparableRequest, function (value) {
                    console.log('value back', value);

                    if (value.comparisons.length === value.comparableParameterGroups.length) {
                        for (var j = 0; j < value.comparableParameterGroups.length; j++) {
                            var filteredPart = [];
                            // push an empty array (by reference) for each unique part result
                            $scope.formattedUniqueParts.push(filteredPart);

                            for (var k = 0; k < value.comparableParameterGroups[j].length; k++) {

                                $scope.pushParameterIfNotExist(
                                    $scope.parameterNames,
                                    value.comparableParameterGroups[j][k] // Parameter
                                );
                                filteredPart[value.comparableParameterGroups[j][k].name + '_' + value.comparableParameterGroups[j][k].id] = $scope.getLanguageValue(
                                    value.comparableParameterGroups[j][k].value
                                );
                            }
                        }
                    }
                }, function (error) {
                    console.error('bad', error);
                });

                if ($window.ga) {
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Compare',
                        eventAction: 'comparing',
                        eventLabel: $scope.comparisons.length
                    });
                }

                if ($window.ga) {
                    var comparedParts = [];
                    for (var i = 0; i < $scope.comparisons.length; i++) {
                        comparedParts.push($scope.comparisons[i].uniquePn);
                    }

                    var compareList = comparedParts.join(', ');

                    if ($window.ga) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'Compare',
                            eventAction: 'compared',
                            eventLabel: compareList
                        });
                    }
                }
            }
        });
    };

    $scope.init();
}
